import { Workout } from './workout';
import { SportActivity } from './sport-activity';
import { Meal, MealLog } from './meal';
import { Chat } from './chat';
import { RecordedSession } from './recorded-session';
import { BodyMeasurement } from './body-measurement';

// Main db export with all domain operations
export const db = {
  Workout,
  SportActivity,
  MealLog,
  Meal,
  Chat,
  RecordedSession,
  BodyMeasurement,
  // TODO: Add other domains as they are implemented
  // User,
  // Progress,
};

// Individual exports (optional)
export {
  Workout,
  SportActivity,
  MealLog,
  Chat,
  RecordedSession,
  BodyMeasurement,
};

// Core utilities
export * from './core';
